import React from 'react';
import PropTypes from 'prop-types';

import Button from '@Components/Button';

import './Dropdown.custom.scss';

export default function DropdownCloseButton (props) {
  const {
    close,
    closeButton,
  } = props;

  if (!closeButton) {
    return null;
  }

  return (
    <Button
      onClick={()=> {
        close();
      }}
      buttonConfig={{
        className: 'new-dropdown-close-button',
        type: 'link',
        size: 'tiny',
        e2eName: 'close-sort-by',
        ariaLabel: 'Close',
      }}
      iconConfig={{
        name: 'delete',
        size: 'tiny',
      }}
    />
  );
}

DropdownCloseButton.propTypes = {
  close: PropTypes.func.isRequired,
  closeButton: PropTypes.bool,
};
